import React from 'react';
import { slide as Menu } from 'react-burger-menu';
import { withPrefix } from 'gatsby-link';

import './_navmenu.scss';

class NavMenu extends React.Component {
  showSettings = (event) => {
    event.preventDefault();
  }

  render() {
    return (
      <Menu right width={ '100%' } bodyClassName={ "burger-menu-is-open" }>
        <div class="text-left logo">
          <img class="img-fluid logo-img" alt="FirstStep logo" src={withPrefix('/images/logos/logo.png')} />
          <span class="logo-text">FirstStep</span>
        </div>
        <a id="home" className="menu-item" href="/">Home</a>
        <a id="how-to-firststep" className="menu-item" href="/how-to-firststep">How to FirstStep</a>
        <a id="about" className="menu-item" href="/about">About us</a>
        <a id="price" className="menu-item" href="/pricing">Pricing</a>
        <a id="why-firststep" className="menu-item" href="/why-firststep">Why FirstStep</a>
        <a id="white-labelling" className="menu-item" href="/white-labelling">White Labelling</a>
        <a id="faq" className="menu-item" href="/faq">FAQ</a>
        <a id="press" className="menu-item" href="/press">Press</a>
        {/* <a id="download" className="menu-item" href="">Download</a> */}
        <br/>
        <hr/>
        <br/>
        <div class="download-links">
          <a href="https://itunes.apple.com/au/app/firststep/id1139641100" target="_blank" rel="noopener" className="btn-download appstore"><img class="img-fluid" src="/images/logos/app-stores/app-store-button.png" alt="App Store download icon" /></a>
          <a href="https://play.google.com/store/apps/details?id=co.firststep.app" target="_blank" rel="noopener" className="btn-download playstore"><img class="img-fluid" src="/images/logos/app-stores/play-store-button.png" alt="Google Play download icon"/></a>
        </div>
      </Menu>
    );
  }
}

export default NavMenu;



// WEBPACK FOOTER //
// ./src/components/navmenu/index.js